// src/data/questions.js
export const questions = {
    geography: [
      {
        question: "Cual es la capital de Francia?",
        options: ["Paris", "London", "Berlin", "Madrid"],
        answer: "Paris"
      },

      {
        question: "¿Cuál es el río más largo del mundo??",
        options: ["Amazonas", "Nilo", "Yangtsé", "Misisipi"],
        answer: "Nilo"
      },

      {
        question: "¿Cuál es el país más grande del mundo por superficie?",
        options: ["Canadá", "Estados Unidos", "China", "Rusia"],
        answer: "Rusia"
      },

      {
        question: "¿Qué país tiene la mayor población del mundo?",
        options: ["Estados Unidos", "India", "Indonesia", "China"],
        answer: "China"
      },

      {
        question: "¿Qué océano es el más grande del mundo?",
        options: ["Atlántico", "Índico", "Pacífico", "Ártico"],
        answer: "Pacífico"
      },
      
    ],
    history: [
      {
        question: "Cual fue el primer presidente de Estados Unidos?",
        options: ["George Washington", "Abraham Lincoln", "Thomas Jefferson", "John Adams"],
        answer: "George Washington"
      },

      {
        question: "¿Quién descubrió América?",
        options: ["Cristóbal Colón", "Marco Polo", "Thomas Edison", "Albert Einstein"],
        answer: "Cristóbal Colón"
      },

      {
        question: "¿Qué gran muralla se puede ver desde el espacio?",
        options: ["La Muralla de Berlín", "La Gran Muralla China", "El Muro de Adriano", "El Muro de México"],
        answer: "La Gran Muralla China"
      },

      {
        question: "¿Quién pintó la Mona Lisa?",
        options: ["Vincent van Gogh", "Pablo Picasso", "Leonardo da Vinci", "Miguel Ángel"],
        answer: "Leonardo da Vinci"
      },
      
      {
        question: "¿Quién fue el faraón más famoso de Egipto?",
        options: ["Ramsés II", "Tutankamón", "Cleopatra", "Akenatón"],
        answer: "Tutankamón"
      },

    ],
    culture: [
      {
        question: "¿Cual es el baile tradicional de Argentina?",
        options: ["Samba", "Tango", "Flamenco", "Waltz"],
        answer: "Tango"
      },

      {
        question: "¿Qué personaje de Disney perdió un zapato de cristal?",
        options: ["Blancanieves", "Ariel", "Cenicienta", "Rapunzel"],
        answer: "Cenicienta"
      },

      {
        question: "¿Qué fruta se utiliza para hacer vino?",
        options: ["Manzana", "Naranja", "Uva", "Plátano"],
        answer: "Uva"
      },

      {
        question: "¿Qué fruta se utiliza para hacer vino?",
        options: ["Manzana", "Naranja", "Uva", "Plátano"],
        answer: "Uva"
      },

      {
        question: "¿Qué instrumento musical toca Lisa Simpson?",
        options: ["Guitarra", "Piano", "Saxofón", "Violín"],
        answer: "Saxofón"
      },
      
    ],
  };
  